import { Component, OnInit } from '@angular/core';
import { VERSAO_CVS } from 'src/app/services/autorizacao-api';
import { BusinessService } from '../../../services/business.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  versaoCVS: string = VERSAO_CVS;

  constructor(private businessService: BusinessService) { }

  ngOnInit() {
  }

  mostrarSeloANSHapvida() {
    return (this.businessService.getBusinessId() === '1');
  }

}
